import { Button } from '@cian/ui-kit';

import * as styles from './styles.css';
import React, { useLayoutEffect } from 'react';
import { getDeclension, useStuckState } from './utils';
import { useSelector } from 'react-redux';
import { selectMasterButton } from '../../../selectors/landing';
import { ETestIds } from '../../../constants/testIds';
import { useTracking } from '../../../utils/tracking/useTracking';

export interface IScrollToOffersButtonProps {
  isLoading: boolean;
  offersCount: number | null;
}

export const ScrollToOffersButton: React.FC<IScrollToOffersButtonProps> = ({ isLoading, offersCount }) => {
  const { trackMobileShowButtonAmountOffers } = useTracking();
  const countWordForm = getDeclension(offersCount);
  const currentStickyButton = useSelector(selectMasterButton);
  const { stuck, buttonRef } = useStuckState();
  const showOffersActive = currentStickyButton === 'showOffers';

  useLayoutEffect(() => {
    const el = buttonRef.current;
    if (!el) {
      return;
    }
    el.classList.toggle(styles['stuck'], stuck);
    el.classList.toggle(styles['visible'], showOffersActive);
  }, [stuck, showOffersActive]);

  const onClickHandler = () => {
    const offerList = document.querySelector(`[data-testid=${ETestIds.OfferListContainer}]`);
    offerList?.scrollIntoView({
      behavior: 'smooth',
    });
    trackMobileShowButtonAmountOffers(offersCount);
  };

  return (
    <div ref={buttonRef} suppressHydrationWarning className={styles['container']}>
      <Button size="M" fullWidth loading={isLoading} data-testid={ETestIds.ShowOffersButton} onClick={onClickHandler}>
        Показать {countWordForm}
      </Button>
    </div>
  );
};
